/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Order_Recreate_ErrorInputs */

const vi_toast_order_recreate_error = /** @type {(inputs: Toast_Order_Recreate_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tạo lại được đơn`)
};

/**

* @param {Toast_Order_Recreate_ErrorInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_order_recreate_error = /** @type {((inputs?: Toast_Order_Recreate_ErrorInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Order_Recreate_ErrorInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_order_recreate_error(inputs)
});